import type { BifrostWeb } from '@seekrtech/bifrost-web'
import type { Result } from '../types'

export type PaywallType = 'trial' | 'permanent'

export interface PaywallServiceMethods {
  openPaywall: (
    type: PaywallType,
    enter_from?: string,
  ) => Promise<Result<null, 'failed_to_open'>>
}

export function createPaywallService(
  bifrost: BifrostWeb,
): PaywallServiceMethods {
  return bifrost
    .createProxyBuilder<PaywallServiceMethods>('PaywallService')
    .withDefaultOptions({ timeout: 31_536_000_000 })
    .build()
}
